import { SubmissionCommentTargetType } from '../../commonv3/types/submission_comments';
import { MainV3ApiBase } from './base';
import { SubmissionCommentIndexView } from '../types/submission_comments';
import { RawHtml } from '../../commonv3/types/block';

export type SubmissionCommentCreateRequest = {
  content: RawHtml;
};

export const SubmissionCommentApis = {
  findAll(targetType: SubmissionCommentTargetType, targetId: number): Promise<SubmissionCommentIndexView[]> {
    return MainV3ApiBase.appendPath('/submission_comments').get({
      target_type: targetType,
      target_id: targetId,
    });
  },
  create(
    targetType: SubmissionCommentTargetType,
    targetId: number,
    request: SubmissionCommentCreateRequest
  ): Promise<SubmissionCommentIndexView> {
    return MainV3ApiBase.appendPath('submission_comments').post({
      target_type: targetType,
      target_id: targetId,
      ...request,
    });
  },
};
